import { recordLockMixin } from '@/mixins/common/recordLockMixin'
export const promptOnExitMixin = {
  data() {
    return {
      routeTo: undefined,
      skipPrompt: false,
      promptLeave: false
    }
  },
  methods: {
    doExit(title) {
      let recKey = ''
      try {
        if (title !== undefined) {
          if (title === 'Receipt') {
            recKey = this.getRecKey(this.receiptsForm)
          } else if (title === 'Payment') {
            recKey = this.getRecKey(this.paymentForm)
          } else if (title === 'Credit Note') {
            recKey = this.getRecKey(this.creditNoteForm)
          } else if (title === 'Debit Note') {
            recKey = this.getRecKey(this.debitNoteForm)
          } else if (title === 'RI Header') {
            recKey = 'RI|' + this.riForm.polNo + '|' + this.riForm.renCnt + '|' + this.riForm.endtCnt
          } else if (title === 'NonTrade') {
            recKey = this.getRecKey(this.nonTradeForm)
          } else if (title === 'Multiple Account Receipt') {
            recKey = 'MUL|' + this.mulAcctRcptForm.transactionType + '|' +
                  this.mulAcctRcptForm.branch + '|' +
                  this.mulAcctRcptForm.documentNo + '|' +
                  this.mulAcctRcptForm.fund
          } else if (title === 'Multiple Account Payment') {
            recKey = 'MUL|' + this.mulAcctPayForm.transactionType + '|' +
                  this.mulAcctPayForm.branch + '|' +
                  this.mulAcctPayForm.documentNo + '|' +
                  this.mulAcctPayForm.fund
          }
        }
        // AR: OS-660 Unlock Record upon exit 29-Jan-2021
        if (recKey !== '') {
          // console.log(recKey)
          this.unlockRecord(recKey, 'ACT')
        }
        this.skipPrompt = true
        this.$router.push(this.routeTo.path)
      } catch (e) { }
    },
    async doSaveAndExit(title, tranMode) {
      let recKey = ''
      // Each page should listen to this and do partial submit and save
      if (title === 'Receipt') {
        if (tranMode === 'R') {
          this.doSaveReceipt('UPDATE_SAVE_REVIEW')
        } else {
          this.doSaveReceipt('CREATE_SAVE_REVIEW')
        }
        recKey = this.getRecKey(this.receiptsForm)
      } else if (title === 'Payment') {
        this.doSavePayment('CREATE_SAVE_REVIEW')
        recKey = this.getRecKey(this.paymentForm)
      } else if (title === 'Debit Note') {
        this.doSaveDebitNote('CREATE_SAVE_REVIEW')
        recKey = this.getRecKey(this.debitNoteForm)
      } else if (title === 'Credit Note') {
        this.doSaveCreditNote('CREATE_SAVE_REVIEW')
        recKey = this.getRecKey(this.creditNoteForm)
      } else if (title === 'RI Header') {
        if (tranMode === 'RI Header') {
          this.doSaveRiHeader()
          this.doExit(title)
        } else if (tranMode === 'RI Details') {
          this.doSaveRiDetail()
          this.doExit(title)
        }
      } else if (title === 'Journal') {
        this.doSaveJournal()
      } else if (title === 'Multiple Account Payment') {
        if (tranMode === 'R') {
          this.doSavePayment('UPDATE_SAVE_REVIEW')
        } else {
          this.doSavePayment('CREATE_SAVE_REVIEW')
        }
        recKey = 'MUL|' + this.mulAcctPayForm.transactionType + '|' +
                  this.mulAcctPayForm.branch + '|' +
                  this.mulAcctPayForm.documentNo + '|' +
                  this.mulAcctPayForm.fund
      } else if (title === 'Multiple Account Receipt') {
        if (tranMode === 'R') {
          this.doSaveReceipt('CREATE_SAVE_REVIEW')
        } else {
          this.doSaveReceipt('UPDATE_SAVE_REVIEW')
        }
        recKey = 'MUL|' + this.mulAcctRcptForm.transactionType + '|' +
                  this.mulAcctRcptForm.branch + '|' +
                  this.mulAcctRcptForm.documentNo + '|' +
                  this.mulAcctRcptForm.fund
      } else if (title === 'NonTrade') {
        if (tranMode === 'R') {
          this.doSave('CREATE_SAVE_REVIEW')
        } else {
          this.doSave('UPDATE_SAVE_REVIEW')
        }
        recKey = this.getRecKey(this.nonTradeForm)
      }

      // AR: OS-660 Unlock Record upon exit 29-Jan-2021
      if (recKey !== '') {
        // console.log(recKey)
        this.unlockRecord(recKey, 'ACT')
      }
    },
    getRecKey(formData) {
      let recKey = formData.transactionType + '|' +
                  formData.branch + '|' +
                  formData.accountNo + '|' +
                  formData.documentNo + '|' +
                  formData.fund + '|' +
                  formData.accountNoSuffix
      return recKey
    }
  },
  // If user tries to leave this page, it will prompt leave message
  beforeRouteLeave(to, from, next) {
    if (this.skipPrompt) {
      next()
    } else {
      this.routeTo = to
      this.promptLeave = true
      next(false)
    }
  },
  created() {
    this.$root.$on('promptOnExitMixin', () => {
      this.doExit()
    })
    // AR: Initialize CommonUtil Menu 29-Jan-2021
    this.initCommonUtilMenu()
  },
  mixins: [
    recordLockMixin
  ],
  beforeDestroy() {
    this.$root.$off('promptOnExitMixin')
  }
}
